import React from 'react'
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { forgotPassFromValidator } from '../../../services/validatior/formValidator/authValidator';
import { useDispatch } from 'react-redux';
import { forgotPasswordEmail } from '../../../redux/reducers/authSlice';
import { useFormik } from 'formik';
const ForgotPassword = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const forgotPassFormik = useFormik({
    initialValues: forgotPassFromValidator.initialValues,
    validationSchema: forgotPassFromValidator.validationSchema,
    onSubmit: async (values) => {
      dispatch(forgotPasswordEmail({
        apiData: values,
        navigate: navigate,
        forgotPassFormik: forgotPassFormik
      }))
      // navigate('/verifyemail',{state:forgotPassFormik?.values.email})
      localStorage.setItem("emailForGotPass", forgotPassFormik?.values.email)

    }
  })
  return (
    <>
      <div className="authentication-wrapper authentication-basic container-p-y verify-m">
        <div className="authentication-inner position-relative">
          {/* Forgot Password */}
          <div className="card verify-card">
            <div className="card-body">
              {/* Logo */}

              <div className="app-brand auth-logo">
                <img src="/assets/images/OHC-Logo.png" alt="" />
              </div>

              {/* /Logo */}
              <h4 className="mb-1 pt-2">Forgot Password?</h4>
              <p className="mb-4">
                Enter your email and we'll send you instructions to reset your
                password
              </p>
              <form onSubmit={forgotPassFormik.handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={forgotPassFormik?.values.email} onChange={forgotPassFormik.handleChange}
                    placeholder="Enter your email"
                    autofocus=""
                  />
                  <p className='form-error-message'>{forgotPassFormik.touched.email &&
                    forgotPassFormik.errors.email}</p>
                </div>
                <button className="btn w-100 mb-3" type="submit">
                  Send OTP
                </button>
              </form>
              <div className="text-center back-log">
                <Link to="/login" className='colour-red'>
                  <FontAwesomeIcon icon={icon({ name: "angle-left" })} />
                  Back to login

                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>

    </>
  )
}

export default ForgotPassword